import {
  Content,
  ContentActionBar,
  ContentMain,
  ContentSideBarLeft,
  ContentSideBarRight,
  ContentTabs,
} from './Content';
import { Root } from './Root';
import { FiltersProvider, ResourceGuard, Wrapper } from './Wrapper';

export const Page = {
  Root,
  ResourceGuard,
  Content,
  ContentActionBar,
  ContentMain,
  ContentSideBarLeft,
  ContentSideBarRight,
  ContentTabs,
  Wrapper,
  FiltersProvider,
};
